import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

//! Fetch all successful payments for an offer
export const getOfferPayments = createAsyncThunk(
  "payment/getOfferPayments",
  async (offerId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/payments/offer/${offerId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch offer payments" }
      );
    }
  }
);

// NOTE: Create Payment Session
export const createPaymentSession = createAsyncThunk(
  "payment/createPaymentSession",
  async (paymentDetails, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/payments/create-session",
        paymentDetails
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to create payment session" }
      );
    }
  }
);

// NOTE: Get User Payments with Filters
export const getUserPayments = createAsyncThunk(
  "payment/getUserPayments",
  async (filterData = {}) => {
    const response = await api.post("payments/user", filterData);
    return response.data;
  }
);

// Get Stripe Connect status for the current user
export const getStripeConnectStatus = createAsyncThunk(
  "stripe/getConnectStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/payment/stripe-status");
      return response.data;
      console.log("Stripe Status Response:", response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch Stripe Connect status",
        }
      );
    }
  }
);

// Initiate Stripe Connect onboarding for the current user
export const initiateStripeConnect = createAsyncThunk(
  "stripe/initiateConnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post("/payment/stripe-onboard");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to initiate Stripe Connect" }
      );
    }
  }
);

// Create Stripe Connect Account
export const createStripeConnect = createAsyncThunk(
  "user/createStripeConnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/payment/connect-stripe");
      console.log("Stripe connect URL generated:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error creating Stripe connect:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to create Stripe connection"
      );
    }
  }
);

//! Admin Payments Dashboard with Filters
export const getAdminPaymentsDashboard = createAsyncThunk(
  "adminPayments/getDashboard",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add all non-empty parameters
      if (params.tab) queryParams.append('tab', params.tab);
      if (params.search) queryParams.append('search', params.search);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.planType) queryParams.append('planType', params.planType);
      if (params.status) queryParams.append('status', params.status);
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);

      const response = await api.get(
        `/admin/payments/dashboard?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashboard data" }
      );
    }
  }
);

//! Cancel Subscription (Admin)
export const cancelSubscription = createAsyncThunk(
  "adminPayments/cancelSubscription",
  async ({ subscriptionId, reason }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/admin/payments/subscription/${subscriptionId}/cancel`,
        { reason }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to cancel subscription" }
      );
    }
  }
);

export const verifyManualPayment = createAsyncThunk(
  "payment/verifyManualPayment",
  async ({ paymentId }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/admin/payments/manual/${paymentId}/verify`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to verify manual payment"
      );
    }
  }
);

export const rejectManualPayment = createAsyncThunk(
  "payment/rejectManualPayment",
  async ({ paymentId }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/admin/payments/manual/${paymentId}/reject`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to reject manual payment"
      );
    }
  }
);
